import React, { useState } from "react";
import EyeIcon from "../../icons/eyeIcon";
import EyeSlashIcon from "../../icons/eyeSlashIcon";
import styles from "./style.module.css";

export default function PasswordInput(props) {
  const { value = "", required, id, placeholder, onChange } = props;
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className={styles.passwordInput_wrapper}>
      <input
        type={showPassword ? "text" : "password"}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        placeholder={placeholder}
        className={styles.passwordInput}
        id={id}
      />
      <div
        className={styles.passwordInput_eye}
        onClick={() => setShowPassword(!showPassword)}
      >
        {showPassword ? <EyeIcon /> : <EyeSlashIcon />}
      </div>
    </div>
  );
}
